import React from 'react';
import Alert from './Alert';
import classNames from 'classnames';
import {SUCCESS__24} from '@homeaway/svg-defs';

function AlertSuccess(props) {
    let buttonClasses = classNames('Alert--success', props.className);
    return (
        <Alert {...props} className={buttonClasses} flairClassName="bg--color-positive" svgClassName="text-success"/>
    );
}

AlertSuccess.propTypes = {
    ...Alert.propTypes
};

AlertSuccess.defaultProps = {
    ...Alert.defaultProps,
    svgMarkup: SUCCESS__24
};

export default AlertSuccess;
